import {
  ICustomerImportOverview,
  ICustomerImport,
  ICustomerImportPagination,
  ICustomerImportStatus,
  ICustomerImportCreateCampaignData,
  ICustomerImportSummaryAndStatistics,
  ICustomerImportElegibleCustomersResponse,
  ICustomerImportGetCampaignData,
  ICustomerImportChangeCampaignData
} from '@/models/customer-import';

import APIService from '.';

interface CustomerListResponse
  extends ICustomerImportPagination<ICustomerImport> {
  importedAt: null | string;
  campaignCreatedAt: null | string;
  total: number;
}

export default class CustomerImportService extends APIService {
  getOverview(providerName: string) {
    return this.get<ICustomerImportOverview>(
      `/admin/customer-lead/${providerName}/report`
    );
  }

  getCustomerImportSummaryAndStatistics(providerName: string) {
    return this.get<ICustomerImportSummaryAndStatistics>(
      `/admin/customer-lead/${providerName}/invitation-campaign/report`
    );
  }

  getCustomeImportsList(resource: string, params: Record<string, any> = {}) {
    return this.get<CustomerListResponse>(resource, {
      params
    });
  }

  getImportStatus(providerName: string) {
    return this.get<ICustomerImportStatus>(
      `/admin/customer-lead/${providerName}/import/status`
    );
  }

  getElegibleCustomers(providerName: string) {
    return this.get<ICustomerImportElegibleCustomersResponse>(
      `/admin/customer-lead/${providerName}/eligible-customers`
    );
  }

  createCampaign({ payload, providerName }: ICustomerImportCreateCampaignData) {
    return this.post(
      `/admin/customer-lead/${providerName}/invitation-campaign`,
      payload
    );
  }

  setCampaign({ payload, campaignId }: ICustomerImportChangeCampaignData) {
    return this.put(
      `/admin/invitation-campaign/${campaignId}/settings`,
      payload
    );
  }

  getCampaign({ campaignId }: ICustomerImportGetCampaignData) {
    return this.get(`/invitation-campaign/${campaignId}`);
  }

  getCampaigns() {
    return this.get(`/admin/invitation-campaign`);
  }

  startImport(providerName: string) {
    return this.post(`/admin/customer-lead/${providerName}/import/start`);
  }
}
